const getLanguageTag = (language) => 
  `language:${language === "ko" ? "korean" : "english"}`;

const hasLanguageTag = (item, language) => {
  const languageTag = getLanguageTag(language);
  return item.tags && item.tags.some(tag => 
    tag.name?.toLowerCase() === languageTag.toLowerCase() ||
    tag?.toLowerCase() === languageTag.toLowerCase() ||
    tag.name?.toLowerCase() === `language:${language.toLowerCase()}` ||
    tag?.toLowerCase() === `language:${language.toLowerCase()}`
  );
};

// 게시물을 언어별로 필터링하는 함수
const filterPostsByLanguage = (posts, language) => {
  return posts.filter(post => hasLanguageTag(post, language));
};

module.exports = {
  getLanguageTag,
  hasLanguageTag,
  filterPostsByLanguage
}; 